export const deleteColumnModalStyle = () => ({
  '.modal-dialog .modal-content .modal-body p.delete-column': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});
